import { Checkbox } from '@savvy-kit/components/checkbox';

import type { CheckboxCellContentProps } from '../../types/cell-types';

export function CheckboxCellContent({
  checked,
  onCheckedChange,
  label,
  description,
  disabled,
  className,
}: CheckboxCellContentProps) {
  return (
    <Checkbox
      checked={checked}
      onCheckedChange={(value) => onCheckedChange?.(value === true)}
      label={label}
      description={description}
      disabled={disabled}
      className={className}
    />
  );
}
